export const EXAMS_ROUTE = 'egzaminy';
